import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "panel" ]

  connect() {
    this.hide();
  }

  toggle() {
    if (this.panelTarget.classList.contains("opacity-0")) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(event) {
    setTimeout(() => {
      // this.panelTarget.classList.add("transition", "ease-in-out", "duration-500", "sm:duration-700");
      this.panelTarget.classList.remove("transform", "opacity-0", "scale-95");
      this.panelTarget.classList.add("transform", "opacity-100", "scale-100");
      // this.panelTarget.classList.remove("transition", "ease-in-out", "duration-500", "sm:duration-700");
    }, 10);
  }

  hide() {
    this.panelTarget.classList.remove("transform", "opacity-100", "scale-100");
    this.panelTarget.classList.add("transform", "opacity-0", "scale-95");
  }
}
